import moment from "moment";
import React, { useContext, useEffect } from "react";
import useProyecto from "../../hooks/useProyecto";
import { AuthContext } from "../../context/AuthContext";
import { ContratosContext } from "../../context/ContratosContext";

const Row = ({ label, value }) => (
  <div className="d-flex border-bottom">
    <div
      className="px-3 py-2 fw-bold text-uppercase small bg-light border-end"
      style={{ minWidth: 140 }}
    >
      {label}
    </div>
    <div className="px-3 py-2 flex-grow-1 bg-white" style={{ minWidth: 0 }}>
      {value || "-"}
    </div>
  </div>
);

const ReporteHeader = ({ reporte }) => {
  const { proyecto, idProyecto } = useProyecto();
  const { user } = useContext(AuthContext);
  const { contratos, getContratosProyecto } = useContext(ContratosContext);

  useEffect(() => {
    if (idProyecto) getContratosProyecto(idProyecto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto]);

  const contratista = Array.isArray(contratos)
    ? [
        ...new Set(
          contratos
            .map((c) => c?.Proveedor?.razon_social)
            .filter(Boolean)
        ),
      ].join(", ")
    : "";

  const supervisor =
    [user?.nombre, user?.apellido].filter(Boolean).join(" ") ||
    user?.correo ||
    "";

  const periodo =
    reporte?.fecha_inicio && reporte?.fecha_fin
      ? `${moment(reporte.fecha_inicio).utc().format("DD MMM")} al ${moment(
          reporte.fecha_fin
        )
          .utc()
          .format("DD MMM YYYY")}`
      : "";

  return (
    <div className="mb-3">
      <div className="border rounded overflow-hidden">
        <Row label="Proyecto" value={proyecto?.nombre} />
        <Row label="Contratista" value={contratista} />
        <Row label="Supervisor" value={supervisor} />
        <div className="d-flex">
          <div
            className="px-3 py-2 fw-bold text-uppercase small bg-light border-end"
            style={{ minWidth: 140 }}
          >
            Periodo
          </div>
          <div className="px-3 py-2 flex-grow-1 bg-white" style={{ minWidth: 0 }}>
            {periodo || "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReporteHeader;
